import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  CalendarContainer,
  SidePanelContainer,
  StyledSelect,
  AvailabilityHeader,
  ClockIcon,
  AvailabilityRow,
  UpdateButton,
  TimeInput,
  IconButton,
  CrossIcon,
  PlusIcon,
  SyncIcon,
  ScheduleSection,
  TimeConfigContainer,
  ConfigSection,
  ConfigHeader,
  SaveButton,
  ButtonText,
  LoadingSpinner,
  SaveIconAlt,
  HeaderGroup,
  NumberInput,
  ConfigTitle,
  ThreeColumnLayout,
  Column,
  Column1,
} from "./styles";
import {
  tieneHorariosConfigurados,
  fetchHorariosByEmpresa,
  getHorariosByEspecialistaAndByEmpresa,
  updateHorarioEmpresa,
  addHorarioEmpresa,
  deleteHorarioEspecialista
} from "../../services/firebase/horariosEspecialistas";
import HorariosForm from "../../components/HorariosForm";

export const Horarios = ({ onSaved }) => {
  const initialDays = [
    'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'
  ].map(label => {
    const isWeekday = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes'].includes(label);
    const isSaturday = label === 'Sábado';

    return {
      label,
      available: isWeekday || isSaturday,
      timeRanges: isWeekday
        ? [{ start: '09:00', end: '13:00' }, { start: '15:00', end: '19:00' }]
        : isSaturday
          ? [{ start: '09:00', end: '13:00' }]
          : []
    };
  });
   const [config, setConfig] = useState({
    duracionCitaMin: "15",
    plazos: {
      enabled: true,
      maxDays: 60,
      minHoursEnabled: true,
      minHours: 4,
      mostrarDisponibilidadDiaria: false
    },
    citasReservadas: {
      duracionPeriodo: {
        enabled: true,
        tiempo: 60
      },
      maxReservas: {
        enabled: true,
        cantidad: 4
      }
    }
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [days, setDays] = useState(initialDays);
  const [timeErrors, setTimeErrors] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [horarioId, setHorarioId] = useState(null); // Para guardar el ID del horario

  const { addToast } = useToasts();
  const empresa = useSelector((state) => state.empresa);
  const usuario = useSelector((state) => state.usuario).data;
  
  // Nuevos estados para manejar la inicialización desde horarios genéricos
  const [tieneHorarios, setTieneHorarios] = useState(false);
  const [horariosGenericos, setHorariosGenericos] = useState([]);
  const [nuevosIds, setNuevosIds] = useState([]);

  
  // Efecto para verificar si la empresa tiene horarios configurados
  useEffect(() => {
    const getHorarios = async () => {
      if (empresa?.id && usuario?.id) {
        
        try {
          //const tieneHors = await tieneHorariosConfigurados(empresa.id);
          //setTieneHorarios(tieneHors);

          // Si no tiene horarios configurados, se cargan los genéricos
            const horarioDetalle = await getHorariosByEspecialistaAndByEmpresa(usuario.id, empresa.id);
            //setHorariosGenericos(genericos);
 // Actualizar el estado con los datos cargados
        setConfig({
          id: horarioDetalle?.id,
          empresaId : horarioDetalle?.empresaId,
          duracionCitaMin: horarioDetalle?.duracionCitaMin || "15",
          plazos: {
            enabled: horarioDetalle?.franjaProgramacion?.anticipacionMaxima?.habilitado ?? false,
            maxDays: horarioDetalle?.franjaProgramacion?.anticipacionMaxima?.dias || 60,
            minHoursEnabled: horarioDetalle?.franjaProgramacion?.anticipacionMinima?.habilitado ?? false,
            minHours: horarioDetalle?.franjaProgramacion?.anticipacionMinima?.horas || 4,
            mostrarDisponibilidadDiaria: horarioDetalle?.franjaProgramacion?.mostrarDisponibilidadDiaria ?? false
          },
          citasReservadas: {
            duracionPeriodo: {
              enabled: horarioDetalle?.ajustesCitaReservada?.duracionPeriodoEntreCitas?.habilitado ?? false,
              tiempo: horarioDetalle?.ajustesCitaReservada?.duracionPeriodoEntreCitas?.tiempo || 60
            },
            maxReservas: {
              enabled: horarioDetalle?.ajustesCitaReservada?.maximoReservasPorDia?.habilitado ?? false,
              cantidad: horarioDetalle?.ajustesCitaReservada?.maximoReservasPorDia?.cantidad || 4
            }
          }
        });
  
  
        setDays(horarioDetalle?.disponibilidad?.map(day => ({
          label: day.dia,
          available: day.disponible,
          timeRanges: day.horarios?.map(range => ({
            start: range.inicio?.slice(0, 5) || "09:00",
            end: range.fin?.slice(0, 5) || "13:00"
          })) || []
        })) || initialDays);
            //await loadHorarios();
setLoading(false)
setIsEditing(true)
            addToast("Se han configurado horarios predeterminados para tu empresa", {
              appearance: "info",
              autoDismiss: true
            });
          
        } catch (error) {
          console.error("Error al verificar horarios:", error);
          setError(error.message || "Error al verificar configuración de horarios");
          addToast(error.message || "Error al verificar configuración de horarios", {
            appearance: "error",
            autoDismiss: true
          });
        }
      }
    };
setLoading(true)
    getHorarios();
    
  }, [empresa?.id, usuario?.id]);

  const updateConfig = (path, value) => {
    setConfig(prev => {
      const newConfig = { ...prev };
      const keys = path.split('.');
      let current = newConfig;

      for (let i = 0; i < keys.length - 1; i++) {
        current[keys[i]] = { ...current[keys[i]] };
        current = current[keys[i]];
      }

      const lastKey = keys[keys.length - 1];

      if (typeof value === 'boolean') {
        current[lastKey] = value;
      }
      else {
        current[lastKey] = value;
      }

      return newConfig;
    });
  };

  const validateTimeRange = (start, end, ranges, currentIndex) => {
    const timeRegex = /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/;
    const toMinutes = time => {
      const [h, m] = time.split(':').map(Number);
      return h * 60 + m;
    };

    const startMin = toMinutes(start);
    const endMin = toMinutes(end);
    const errors = [];

    if (!timeRegex.test(start) || !timeRegex.test(end)) {
      errors.push("Formato inválido (HH:MM)");
    }
    if (startMin >= endMin) {
      errors.push("La hora inicial debe ser anterior a la final");
    }

    ranges.forEach((range, index) => {
      if (index !== currentIndex) {
        const otherStart = toMinutes(range.start);
        const otherEnd = toMinutes(range.end);
        if ((startMin < otherEnd) && (endMin > otherStart)) {
          errors.push("Superposición con otro horario");
        }
      }
    });

    return errors;
  };

  useEffect(() => {
    const newErrors = {};
    days.forEach(day => {
      if (day.available && day.timeRanges.length > 0) {
        day.timeRanges.forEach((range, index) => {
          const errors = validateTimeRange(range.start, range.end, day.timeRanges, index);
          if (errors.length > 0) {
            newErrors[`${day.label}-${index}`] = errors;
          }
        });
      }
    });
    setTimeErrors(newErrors);
  }, [days]);

  const updateTimeRange = (dayLabel, index, type, value) => {
    setDays(prevDays => prevDays.map(day =>
      day.label === dayLabel
        ? {
          ...day,
          timeRanges: day.timeRanges.map((range, i) =>
            i === index ? { ...range, [type]: value } : range
          )
        }
        : day
    ));
  };

  const addTimeRange = (dayLabel) => {
    setDays(prevDays => prevDays.map(day => {
      if (day.label === dayLabel) {
        const newRange = day.timeRanges.length === 0
          ? { start: '09:00', end: '13:00' }
          : { start: '15:00', end: '19:00' };

        return {
          ...day,
          available: true,
          timeRanges: [...day.timeRanges, newRange]
        };
      }
      return day;
    }));
  };


  const deleteTimeRange = (dayLabel, index) => {
    setDays(prevDays => prevDays.map(day =>
      day.label === dayLabel
        ? { ...day, timeRanges: day.timeRanges.filter((_, i) => i !== index) }
        : day
    ));
  };


  const handleSave = async () => {
    if (Object.keys(timeErrors).length > 0) {
      const errorMessage = "¡Existen errores en los horarios! Corrígelos antes de guardar.";
      setError(errorMessage);
      addToast(errorMessage, {
        appearance: "error",
        autoDismiss: true
      });
      return;
    }
    
    setIsSaving(true);
    try {
      
      const formData = {
        duracionCitaMin: parseInt(config.duracionCitaMin, 10),
        disponibilidad: days.map(day => {
          // Asignar numDia basado en el nombre del día
          let numDia;
          switch(day.label) {
            case 'Domingo': numDia = 0; break;
            case 'Lunes': numDia = 1; break;
            case 'Martes': numDia = 2; break;
            case 'Miércoles': numDia = 3; break;
            case 'Jueves': numDia = 4; break;
            case 'Viernes': numDia = 5; break;
            case 'Sábado': numDia = 6; break;
            default: numDia = 0; // Por defecto
          }
          
          return {
            dia: day.label,
            numDia: numDia,
            disponible: day.available,
            horarios: day.timeRanges.map(range => ({
              inicio: range.start,
              fin: range.end
            }))
          };
        }),
        empresaId: empresa.id,
        especialistaId: usuario?.id,
        franjaProgramacion: {
          anticipacionMaxima: {
            dias: config.plazos.maxDays,
            habilitado: config.plazos.enabled
          },
          anticipacionMinima: {
            habilitado: config.plazos.minHoursEnabled,
            horas: config.plazos.minHours
          },
          mostrarDisponibilidadDiaria: config.plazos.mostrarDisponibilidadDiaria || false,
          habilitado: true
        },
        ajustesCitaReservada: {
          duracionPeriodoEntreCitas: {
            tiempo: config.citasReservadas.duracionPeriodo.tiempo,
            unidad: "minutos",
            habilitado: config.citasReservadas.duracionPeriodo.enabled,
          },
          maximoReservasPorDia: {
            habilitado: config.citasReservadas.maxReservas.enabled,
            cantidad: config.citasReservadas.maxReservas.cantidad
          },
          habilitado: true
        },
        updatedAt: new Date().toISOString()
      };
  
      // Si ya hay datos guardados previamente, mantener la fecha de creación original
      // Si es nuevo, establecer la fecha de creación
      if (!tieneHorarios) {
        formData.createdAt = new Date().toISOString();
      }
  
      
      // Usar addHorarioEmpresa que ahora utiliza el especialistaId como ID del documento (upsert)
      const savedId = await addHorarioEmpresa(formData);
      
      setConfig(prev => ({
        ...prev,
        id: savedId,
        empresaId: empresa.id
      }));
      
      addToast("Se guardaron los cambios satisfactoriamente", {
        appearance: "success",
        autoDismiss: true
      });
      
      setIsEditing(true);
      setError(null);
      setTieneHorarios(true);
  
    } catch (err) {
      addToast(err.message || "Error al guardar los horarios", {
        appearance: "error",
        autoDismiss: true
      });
      setError(err.message || "Error al guardar los horarios");
    } finally {
      setIsSaving(false);
      if (onSaved) onSaved(); // Notifica al wizard
    }
  };






  const renderTimeRange = (day, range, index) => (
    <div key={index} className="time-range-container">
      <div className="time-inputs">
        <TimeInput
          type="time"
          value={range.start}
          onChange={(e) => updateTimeRange(day.label, index, 'start', e.target.value)}
          disabled={!isEditing || loading}
          step="900"
          style={{
            border: `2px solid ${timeErrors[`${day.label}-${index}`] ? '#ff0000' : '#0066cc'}`,
            borderRadius: '4px',
            padding: '4px',
            margin: '2px',
            backgroundColor: timeErrors[`${day.label}-${index}`] ? '#ffe6e6' : 'white'
          }}
        />
        <span>-</span>
        <TimeInput
          type="time"
          value={range.end}
          onChange={(e) => updateTimeRange(day.label, index, 'end', e.target.value)}
          disabled={!isEditing || loading}
          step="900"
          style={{
            border: `2px solid ${timeErrors[`${day.label}-${index}`] ? '#ff0000' : '#0066cc'}`,
            borderRadius: '4px',
            padding: '4px',
            margin: '2px',
            backgroundColor: timeErrors[`${day.label}-${index}`] ? '#ffe6e6' : 'white'
          }}
        />
        <IconButton onClick={() => deleteTimeRange(day.label, index)} disabled={!isEditing}>
          <CrossIcon />
        </IconButton>
      </div>
      {timeErrors[`${day.label}-${index}`] && (
        <div className="error-message">
          {timeErrors[`${day.label}-${index}`].map((error, i) => (
            <div key={i}>⚠️ {error}</div>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <HorariosForm
      config={config}
      days={days}
      loading={loading}
      isEditing={isEditing}
      timeErrors={timeErrors}
      onChangeConfig={updateConfig}
      onChangeDays={setDays}
      onSave={handleSave}
      isSaving={isSaving}
      error={error}
    />
  );
};

export default Horarios;